
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/testseries/[eventUid]",
      function () {
        return require("private-next-pages/testseries/[eventUid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/testseries/[eventUid]"])
      });
    }
  